<div class="pill-container d-flex flex-wrap gap-2 {{customClass}}" [class.has-error]="hasError">
  <button
    *ngFor="let item of items"
    type="button" class="pill fs-normal"
    [class.selected]="isSelected(item)"
    [class.disabled]="disabled"
    [attr.aria-pressed]="isSelected(item)"
    [disabled]="disabled"
    (click)="selectItem(item)">{{itemLabel(item)}}</button>
</div>
